import { t } from "i18next";
import { validateRequired } from "../components/EquipmentList/equipmentlist.functions";

export type NameDescriptionRow = {
  name?: string;
  description?: string;
};

export type NameDescriptionValidationResult = {
  name: string;
  description: string;
};

/**
 * Validates a row with optional name and description.
 * Name: required, max 75 characters.
 * Description: required, max 1000 characters.
 */
export function validateNameDescriptionRow(
  row: Partial<NameDescriptionRow>
): NameDescriptionValidationResult {
  const validateValue = (isEmpty: boolean, emptyStr: string, nextCheck: string) =>
    isEmpty ? emptyStr : nextCheck;
  const validateTypeLength = (isInvalid: boolean, invalidStr: string) =>
    isInvalid ? invalidStr : "";

  const nameEmpty = t("Name cannot be empty");
  const nameExceed = t("Name cannot exceed 75 characters");
  const descEmpty = t("Description cannot be empty");
  const descExceed = t("Description cannot exceed 1000 characters");

  const nameLength = row.name?.length ?? 0;
  const descLength = row.description?.length ?? 0;

  const isNameLength = validateTypeLength(nameLength > 75, nameExceed);
  const isNameValid = validateValue(!validateRequired(row.name), nameEmpty, isNameLength);

  const isDescLength = validateTypeLength(descLength > 1000, descExceed);
  const isDescValid = validateValue(!validateRequired(row.description), descEmpty, isDescLength);

  return {
    name: isNameValid,
    description: isDescValid
  };
}

/**
 * Fleet (and similar) rows: name required (max 75). Description optional; if present, max 1000 characters.
 */
export function validateNameWithOptionalDescription(
  row: Partial<NameDescriptionRow>
): NameDescriptionValidationResult {
  const validateValue = (isEmpty: boolean, emptyStr: string, nextCheck: string) =>
    isEmpty ? emptyStr : nextCheck;
  const validateTypeLength = (isInvalid: boolean, invalidStr: string) =>
    isInvalid ? invalidStr : "";

  const nameEmpty = t("Name cannot be empty");
  const nameExceed = t("Name cannot exceed 75 characters");
  const descExceed = t("Description cannot exceed 1000 characters");

  const nameLength = row.name?.length ?? 0;
  const descLength = row.description?.length ?? 0;

  const isNameLength = validateTypeLength(nameLength > 75, nameExceed);
  const isNameValid = validateValue(!validateRequired(row.name), nameEmpty, isNameLength);

  const isDescValid = validateTypeLength(descLength > 1000, descExceed);

  return {
    name: isNameValid,
    description: isDescValid
  };
}
